import React from 'react';
import { Clock, TrendingUp, ArrowUpRight, ArrowDownRight, Bot } from 'lucide-react';

const RecentTrades: React.FC = () => {
  const trades = [
    {
      id: '1',
      type: 'buy',
      amount: '2.5 oz',
      price: '$2,034.50',
      profit: '+$125.30',
      time: '2 min ago',
      isAI: true,
      status: 'completed'
    },
    {
      id: '2',
      type: 'sell',
      amount: '1.8 oz',
      price: '$2,031.20',
      profit: '+$89.45',
      time: '15 min ago',
      isAI: false,
      status: 'completed'
    },
    {
      id: '3',
      type: 'buy',
      amount: '3.2 oz',
      price: '$2,028.90',
      profit: '+$203.67',
      time: '1 hour ago',
      isAI: true,
      status: 'completed'
    },
    {
      id: '4',
      type: 'sell',
      amount: '0.9 oz',
      price: '$2,035.75',
      profit: '-$23.12',
      time: '2 hours ago',
      isAI: false,
      status: 'completed'
    },
    {
      id: '5',
      type: 'buy',
      amount: '1.5 oz',
      price: '$2,032.40',
      profit: 'Pending',
      time: '3 hours ago',
      isAI: true,
      status: 'pending'
    }
  ];

  return (
    <div className="win-card p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-win-dark-text">Recent Trades</h2>
        <button className="text-win-dark-accent hover:text-win-dark-accent-hover font-medium text-sm">
          View All
        </button>
      </div>

      <div className="space-y-3">
        {trades.map((trade) => (
          <div key={trade.id} className="win-trade-card group">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                {/* Trade Type Icon */}
                <div className={`p-2 rounded-2xl ${
                  trade.type === 'buy' 
                    ? 'bg-green-500/20' 
                    : 'bg-red-500/20'
                }`}>
                  {trade.type === 'buy' ? (
                    <ArrowUpRight className={`w-4 h-4 ${
                      trade.type === 'buy' ? 'text-green-400' : 'text-red-400'
                    }`} />
                  ) : (
                    <ArrowDownRight className="w-4 h-4 text-red-400" />
                  )}
                </div>

                {/* Trade Details */}
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`font-medium text-sm uppercase ${
                      trade.type === 'buy' ? 'text-green-400' : 'text-red-400'
                    }`}>
                      {trade.type}
                    </span>
                    <span className="text-win-dark-text font-medium">
                      {trade.amount}
                    </span>
                    {trade.isAI && (
                      <div className="flex items-center gap-1 px-2 py-0.5 bg-win-dark-accent/20 rounded-full">
                        <Bot className="w-3 h-3 text-win-dark-accent" />
                        <span className="text-xs text-win-dark-accent font-medium">AI</span>
                      </div>
                    )}
                  </div>
                  <div className="flex items-center gap-4 text-sm text-win-dark-text-muted">
                    <span>@ {trade.price}</span>
                    <div className="flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      <span>{trade.time}</span>
                    </div>
                  </div>
                </div>

                {/* Profit/Loss */}
                <div className="text-right">
                  {trade.status === 'pending' ? (
                    <div className="win-badge win-badge-warning">Pending</div>
                  ) : (
                    <div className={`font-medium ${
                      trade.profit.startsWith('+') 
                        ? 'text-green-400' 
                        : trade.profit.startsWith('-') 
                        ? 'text-red-400' 
                        : 'text-win-dark-text-muted'
                    }`}>
                      {trade.profit}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Summary Stats */}
      <div className="mt-6 pt-4 border-t border-win-dark-border">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <p className="text-2xl font-bold text-green-400">15</p>
            <p className="text-sm text-win-dark-text-muted">Winning Trades</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-red-400">4</p>
            <p className="text-sm text-win-dark-text-muted">Losing Trades</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-win-dark-text">78.9%</p>
            <p className="text-sm text-win-dark-text-muted">Win Rate</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentTrades;